<template>
    <v-footer :color="kingsGreen" app dark>
        <span>King's University College</span>
        <v-spacer></v-spacer>
        <span>&copy; 2020</span>
    </v-footer>
</template>

<script>
export default {
    name: 'student-footer',
    computed: {
        kingsGreen() {
            return '#004236';
        }
    }
}
</script>